import script from "./NotificacionesDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificacionesDrawer.vue?vue&type=script&setup=true&lang=js"

import "./NotificacionesDrawer.vue?vue&type=style&index=0&id=b74161de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b74161de"]])

export default __exports__